import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const DrawLocation_NORDX = () => {
  const navigate = useNavigate();

  useEffect(() => {

    window.open('https://www.mainehealth.org/nordx/locations-nordx', 'draw_location', 'noopener,noreferrer');
    navigate('/');
  }, [navigate]);

  return null;
};

export default DrawLocation_NORDX;
